"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const helpers_1 = require("@app/helpers");
const uiConfigs_1 = require("@app/constants/uiConfigs");
const exercise_1 = require("@components/container/exercise");
const Pagination_1 = require("@components/Pagination");
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const WordItem_1 = __importDefault(require("./WordItem"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const sendInfoReport_1 = require("@app/utils/sendInfoReport");
const useBeforeUnloadReport_1 = require("@hooks/useBeforeUnloadReport");
const DropContainerWrapper = styled_components_1.default.div `
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  align-items: self-start;
  justify-content: end;
  height: 100%;
  @media (max-width: 1200px) {
    justify-content: center;
  }
  @media (max-width: 700px) {
    flex-wrap: wrap-reverse;
  }
`;
const DropWrapper = styled_components_1.default.div `
  width: fit-content;
  gap: 10px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`;
const WordsWrapper = styled_components_1.default.div `
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  border: 1px dashed #6E76FB;
  min-height: 200px;
  background-color: #f5f5f5;
  border-radius: 25px;
  padding: 30px 20px;
`;
const DraggableWord = ({ wordObj, index, zone, isHovering, onHover, onLeave }) => {
    const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)(() => ({
        type: 'word',
        item: Object.assign(Object.assign({}, wordObj), { index, zone }),
        canDrag: !wordObj.isCorrect,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [wordObj.isCorrect]);
    const handlePlayAudio = (e) => {
        e.stopPropagation(); // чтобы не мешать DnD
        audioPlayer_1.audioPlayer.playAudio('x', (wordObj === null || wordObj === void 0 ? void 0 : wordObj.audio) || ""); // или другой url в зависимости от langId
    };
    return (react_1.default.createElement(WordItem_1.default, { wordObj: wordObj, isHovering: isHovering, onHover: onHover, onLeave: onLeave, isDragging: isDragging, dragRef: drag, handlePlayAudio: handlePlayAudio, zone: zone }));
};
const DropZone = ({ items, moveWord, zone }) => {
    const dropRef = (0, react_1.useRef)(null);
    const [hoveredIndex, setHoveredIndex] = (0, react_1.useState)(null);
    const [, drop] = (0, react_dnd_1.useDrop)(() => ({
        accept: 'word',
        hover: (draggedWord, monitor) => {
            var _a, _b;
            if (!dropRef.current)
                return;
            const hoverBoundingRect = dropRef.current.getBoundingClientRect();
            const hoverClientX = (_a = monitor.getClientOffset()) === null || _a === void 0 ? void 0 : _a.x;
            if (hoverClientX && hoverBoundingRect) {
                const hoverRelativeX = hoverClientX - hoverBoundingRect.left;
                const itemWidth = hoverBoundingRect.width / Math.max(1, items.length || 1);
                let hoverIndex = Math.min(items.length, Math.max(0, Math.floor(hoverRelativeX / itemWidth)));
                // Запретить hover на уже правильной карточке
                if ((_b = items[hoverIndex]) === null || _b === void 0 ? void 0 : _b.isCorrect)
                    return; // ничего не делаем, запрет перемещать сюда
                const draggedIndex = items.findIndex(w => w.id === draggedWord.id);
                if (draggedIndex !== -1 && hoverIndex > draggedIndex) {
                    hoverIndex = Math.min(hoverIndex, items.length - 1);
                }
                if (hoveredIndex !== hoverIndex) {
                    setHoveredIndex(hoverIndex);
                    moveWord(draggedWord, zone, hoverIndex, false);
                }
            }
        },
        drop: (draggedWord) => {
            var _a;
            if (hoveredIndex !== null && ((_a = items[hoveredIndex]) === null || _a === void 0 ? void 0 : _a.isCorrect)) {
                setHoveredIndex(null);
                return; // запретить дроп сюда
            }
            moveWord(draggedWord, zone, hoveredIndex !== null ? hoveredIndex : -1, true);
            setHoveredIndex(null);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    }), [moveWord, zone, items]);
    (0, react_1.useLayoutEffect)(() => {
        if (dropRef.current) {
            drop(dropRef);
        }
    }, [drop]);
    return (react_1.default.createElement(WordsWrapper, { ref: dropRef }, items.map((wordObj, index) => (react_1.default.createElement(DraggableWord, { key: wordObj.id, wordObj: wordObj, index: index, moveWord: moveWord, zone: zone, isHovering: hoveredIndex === index, onHover: () => setHoveredIndex(index), onLeave: () => setHoveredIndex(null) })))));
};
let infoRep = [];
let checkedAnswer = [];
const StoryPhraseBuilder = ({ response, description, langId }) => {
    const [initialWords, setInitialWords] = (0, react_1.useState)([]);
    const [, setWords] = (0, react_1.useState)([]);
    const [sentence, setSentence] = (0, react_1.useState)([]);
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const [checkButtons, setCheckButtons] = (0, react_1.useState)(uiConfigs_1.initialButtonState);
    (0, useBeforeUnloadReport_1.useBeforeUnloadReport)(() => ({ infoRep, exerciseId: (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), checkedAnswer }));
    const handleAddCoin = () => addCoin(3, 5);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (response) {
            setSentence((0, helpers_1.shuffleArray)((_a = response === null || response === void 0 ? void 0 : response.text) === null || _a === void 0 ? void 0 : _a.offers));
            setInitialWords((_b = response === null || response === void 0 ? void 0 : response.text) === null || _b === void 0 ? void 0 : _b.offers.sort((a, b) => a.order - b.order));
            infoRep = [{ rep_id: 1, category_name: '', system_time: '', startTime: Date.now() }];
            checkedAnswer = uiConfigs_1.initialButtonState;
        }
    }, [response]);
    const updateWordsAndPlaySound = (prevWords, draggedWord, hoverIndex, withCheck) => {
        const newWords = [...prevWords];
        const draggedIndex = newWords.findIndex(w => w.id === draggedWord.id);
        if (draggedIndex !== -1)
            newWords.splice(draggedIndex, 1);
        const newIndex = hoverIndex >= 0 ? hoverIndex : newWords.length;
        // Вставляем элемент (без проверки, если это ещё не финальный drop)
        newWords.splice(newIndex, 0, Object.assign({}, draggedWord));
        // Если это не финальный drop — возвращаем список как есть
        if (!withCheck)
            return newWords;
        // Проверяем только перемещённый элемент
        const movedWord = newWords[newIndex];
        const isCorrect = movedWord.order === newIndex + 1;
        // Обновляем только его
        newWords[newIndex] = Object.assign(Object.assign({}, movedWord), { isCorrect });
        audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(1, `${isCorrect ? 'correct' : 318}`));
        const updatedWords = newWords.map((word, index) => {
            if (word.isCorrect !== undefined)
                return Object.assign(Object.assign({}, word), { isCorrect: word.order === index + 1 });
            return word;
        });
        return updatedWords;
    };
    const moveWord = (draggedWord, toZone, hoverIndex = -1, withCheck = true) => {
        const setters = { 'sentence': setSentence, 'words': setWords };
        setters[toZone](prev => updateWordsAndPlaySound(prev, draggedWord, hoverIndex, withCheck));
    };
    const checkSentence = () => {
        if ((initialWords === null || initialWords === void 0 ? void 0 : initialWords.length) !== (sentence === null || sentence === void 0 ? void 0 : sentence.length)) {
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
            return false;
        }
        const updatedSentence = sentence === null || sentence === void 0 ? void 0 : sentence.map((word, index) => {
            if (initialWords[index].order === word.order) {
                return Object.assign(Object.assign({}, word), { isCorrect: true });
            }
            else {
                return Object.assign(Object.assign({}, word), { isCorrect: false });
            }
        });
        setSentence(updatedSentence);
        const checkedResul = initialWords.every((item, index) => item.order === sentence[index].order);
        infoRep = (0, sendInfoReport_1.trackAttemptTime)(infoRep, checkedResul);
        if (checkedResul) {
            handleAddCoin();
            // @ts-ignore
            window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
            // @ts-ignore
            (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
        }
        else {
            audioPlayer_1.audioPlayer.playAudio((0, audioPlayer_1.getPreloadSoundKey)(langId, 318));
            infoRep = [...infoRep, { rep_id: infoRep.length + 1, category_name: '', system_time: '', startTime: Date.now() }];
        }
        return checkedResul;
    };
    const handleCheckButtonClick = () => {
        setCheckButtons((prevButtons) => {
            const indexToUpdate = prevButtons.findIndex(button => !button.isChecked);
            if (indexToUpdate === -1) {
                // @ts-ignore
                window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                // @ts-ignore
                (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                return prevButtons;
            }
            const updatedButtons = prevButtons.map((button, index) => {
                if (index === indexToUpdate) {
                    if (indexToUpdate === (checkButtons === null || checkButtons === void 0 ? void 0 : checkButtons.length) - 1) {
                        // @ts-ignore
                        window.stopExercise(true, true, response === null || response === void 0 ? void 0 : response.id);
                        // @ts-ignore
                        (0, sendInfoReport_1.sendInfoReport)(infoRep, (response === null || response === void 0 ? void 0 : response.number) || (response === null || response === void 0 ? void 0 : response.id), window.userId, checkedAnswer);
                    }
                    return Object.assign(Object.assign({}, button), { isChecked: true, isCorrect: checkSentence() });
                }
                return button;
            });
            checkedAnswer = updatedButtons;
            return updatedButtons;
        });
    };
    return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend },
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, null,
                react_1.default.createElement(DropContainerWrapper, null,
                    react_1.default.createElement(DropWrapper, null,
                        react_1.default.createElement(DropZone, { items: sentence, moveWord: moveWord, zone: "sentence" })),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, checkButtons.map((item, index) => react_1.default.createElement(Pagination_1.PaginationItem, { key: index, item: item, active: item.isCorrect && item.isChecked ? "linear-gradient(130deg, #6cff4f 13.21%, #13c21c 81.73%)" : !item.isCorrect && item.isChecked ? "#FF1431" : null })))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { isShowShadow: false, label: (0, translations_1.getLabelCheckButton)(langId), onClick: handleCheckButtonClick, isCheckButton: true }))))));
};
exports.default = StoryPhraseBuilder;
